// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RpcApiError } from '@interfaces/api.interfaces';
import { ErrorModalComponent } from '../modals/error-modal/error-modal.component';

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    constructor(private readonly dialog: MatDialog) {}

    //Used to display an error at anytime in the app.
    showError(error: RpcApiError | string | undefined) {
        this.showErrorAtService(error);
    }

    //Should only be used when wanting to handle the error in a service or component with additional logic/action on error.
    showErrorAtService(error: RpcApiError | string): MatDialogRef<ErrorModalComponent, void> {
        const dl = this.dialog.open(ErrorModalComponent, {
            width: '700px',
            closeOnNavigation: false,
            data: this.prepareError(error),
            autoFocus: true,
        });

        dl.afterClosed().subscribe((result) => this.dialog.closeAll());

        return dl;
    }

    showGenericError() {
        return this.showErrorAtService({
            title: 'Action Could Not be Completed',
            message:
                'The action you were trying to take could not be completed. Please close this message and try again. If you continue to experience problems, contact the support team.',
        });
    }

    showWhitelistError() {
        return this.showErrorAtService({
            title: 'Access to EZ DOCS is Restricted',
            message:
                'The EZ DOCS domains may not be whitelisted on the dealership\'s networks. For quick access, you can temporarily disable the WiFi connection on a mobile device and log in using the mobile network. For future access, make sure the following domains have been whitelisted on your dealership networks, including your guest network. Please also make sure any emails coming from these domains (including from support@) are identified as "safe" so they get delivered to users inboxes.',
            modalList: ['ezdocs123.com', 'digitaldealjacket.com', 'digitaldealjacket.net'],
        });
    }

    prepareError(error: RpcApiError | string): RpcApiError {
        const payload = { message: '' } as RpcApiError;
        if (typeof error === 'string') {
            payload.message = error;
        } else {
            if (error?.message) {
                payload.message = error.message;
            } else {
                payload.message = 'An unknown error occurred';
            }

            if (error?.title) {
                payload.title = error.title;
            } else if (error?.name) {
                payload.title = error.name;
            }

            if (error?.button) {
                payload.button = error.button;
            }
            if (error?.modalList) {
                payload.modalList = error.modalList;
            }
        }

        return payload;
    }
}
